export abstract class FormConfigBase {
  linkFormPath: string[];
  value?: any;

  constructor( obj: any ) {
    if ( !obj ) { return; }
    this.linkFormPath = obj.linkFormPath ? obj.linkFormPath : [];
    this.value = obj && obj.value ? obj.value : '';
  }
}
